// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3qM3y","errorLogs":"styles_errorLogs__BStG9"};